import React, { useEffect, useMemo, useState } from 'react';
import { useStore } from 'store/store';
import { ACCESS_BASE_URL } from 'App';
import {
  useGetCardaccountsClientIdentity
} from '@utx/utx-access-client';

export interface useCardKycInfo {
  cardAccountId: string;
}

export const useCardKycInfo = ({ cardAccountId }: useCardKycInfo) => {
  const store = useStore();
  const [enabled, setEnabled] = useState<boolean>(false);
  setTimeout(() => {
    setEnabled(store.authToken ? true : false);
  }, 100);

  const cardAccountsClientIdentity = useGetCardaccountsClientIdentity(
    {
      cardAccountId: cardAccountId,
    },
    {
      axios: {
        baseURL: ACCESS_BASE_URL
      },
      query: {
        queryKey: ['getCardAccountsClientIdentity', store.authToken, cardAccountId],
        retry: false,
        enabled,
        keepPreviousData: true
      }
    }
  );
  const clientIdentity = useMemo(() => {
    const data = cardAccountsClientIdentity.data?.data;
    return data || [];
  }, [cardAccountsClientIdentity.data?.data]);

  const isLoading = useMemo(() => {
    return cardAccountsClientIdentity.isLoading;
  }, [cardAccountsClientIdentity.isLoading]);

  return {
    clientIdentity,
    isLoading,
    reload: () => cardAccountsClientIdentity.refetch(),
  };
};
